import Navigator from 'app';
const SenateMeetingCollection = Backbone.Collection.extend({
  model: Backbone.Model.extend(),
  initialize: function (method, date) {
    this.date = date;
    this.chamber = "senate"; // used by committee_meeting_collectionview to determine which chamber's data to request
    this.url = Navigator.config.api_base + 'meetings/senate/' + method + '/' + date;
  }
});
const API = {
  getSenateMeetings: function getSenateMeetings(method, date) {
    var defer = $.Deferred();
    var senateMeetings = new SenateMeetingCollection(method, date);
    senateMeetings.fetch({
      dataType: "json",
      success: function (data) {
        defer.resolve(data);
      }
    });
    return defer.promise();
  }
};
Navigator.reqres.setHandler("meetings:senate", (method, date) => {
  return API.getSenateMeetings(method, date);
});
export { SenateMeetingCollection as default };